/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import {
    CommentOutlined,
    FlagOutlined,
    LockOutlined,
    QuestionCircleOutlined,
    // UserOutlined,
} from "@ant-design/icons";

import { List } from "@mui/material";
import React, { useState } from "react";
import { PermissionGuard, PERMISSION } from "cms/auth/permission-guard";
import { MenuItemCard } from "./MenuItemCard";
import { NavLink } from "react-router-dom";

const SettingTab = () => {

    const [selectedIndex, setSelectedIndex] = useState(0);

    const handleListItemClick = (index) => {
        setSelectedIndex(index);
    };

    return (
        <List
            component='nav'
            style={{ padding: 0 }}
            // style={{ padding: 0, '& .MuiListItemIcon-root': { minWidth: 32, color: theme.palette.grey[500] }}}
        >

            {/*<MenuItemCard*/}
            {/*    primary='Personal Settings'*/}
            {/*    icon={<UserOutlined />}*/}
            {/*    index={0}*/}
            {/*    selectedIndex={selectedIndex}*/}
            {/*    setSelectedIndex={setSelectedIndex}*/}
            {/*    onClick={handleListItemClick}*/}
            {/*/>*/}

            <PermissionGuard 
                permission={PERMISSION.ORGANIZATION}
                message={<>org settings</>}
                location={"org settings tab"}
            >
                <MenuItemCard
                    primary='Organization Settings'
                    icon={<FlagOutlined />}
                    index={1}
                    selectedIndex={selectedIndex}
                    setSelectedIndex={setSelectedIndex}
                    onClick={handleListItemClick}
                    component={NavLink}
                    to='/settings/organization-settings'
                />
            </PermissionGuard>

            <MenuItemCard
                primary='Privacy Center'
                icon={<LockOutlined />}
                index={2}
                selectedIndex={selectedIndex}
                setSelectedIndex={setSelectedIndex}
                onClick={handleListItemClick}
            />

            <MenuItemCard
                primary='Feedback'
                icon={<CommentOutlined />}
                index={3}
                selectedIndex={selectedIndex}
                setSelectedIndex={setSelectedIndex}
                onClick={handleListItemClick}
            />

            <MenuItemCard
                primary='Support'
                icon={<QuestionCircleOutlined />}
                index={4}
                selectedIndex={selectedIndex}
                setSelectedIndex={setSelectedIndex}
                onClick={handleListItemClick}
            />

        </List>
    );
};

export { SettingTab };
